var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolderCheckIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 5.75H12.9C14.1601 5.75 14.7902 5.75 15.2715 5.99524C15.6948 6.21095 16.039 6.55516 16.2548 6.97852C16.5 7.45982 16.5 8.08988 16.5 9.35V12.65C16.5 13.9101 16.5 14.5402 16.2548 15.0215C16.039 15.4448 15.6948 15.789 15.2715 16.0048C14.7902 16.25 14.1601 16.25 12.9 16.25H5.1C3.83988 16.25 3.20982 16.25 2.72852 16.0048C2.30516 15.789 1.96095 15.4448 1.74524 15.0215C1.5 14.5402 1.5 13.9101 1.5 12.65V5.75Z",
    fill: "#D3E9E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 5.75L8.91334 4.07669C8.67255 3.5951 8.55215 3.3543 8.37253 3.17837C8.21368 3.0228 8.02224 2.90448 7.81206 2.83198C7.57437 2.75 7.30516 2.75 6.76672 2.75H3.9C3.05992 2.75 2.63988 2.75 2.31901 2.91349C2.03677 3.0573 1.8073 3.28677 1.66349 3.56901C1.5 3.88988 1.5 4.30992 1.5 5.15V5.75M1.5 5.75H12.9C14.1601 5.75 14.7902 5.75 15.2715 5.99524C15.6948 6.21095 16.039 6.55516 16.2548 6.97852C16.5 7.45982 16.5 8.08988 16.5 9.35V12.65C16.5 13.9101 16.5 14.5402 16.2548 15.0215C16.039 15.4448 15.6948 15.789 15.2715 16.0048C14.7902 16.25 14.1601 16.25 12.9 16.25H5.1C3.83988 16.25 3.20982 16.25 2.72852 16.0048C2.30516 15.789 1.96095 15.4448 1.74524 15.0215C1.5 14.5402 1.5 13.9101 1.5 12.65V5.75ZM6.75 11L8.25 12.5L11.625 9.125",
    stroke: "#24352F",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderCheckIcon);
export default __webpack_public_path__ + "static/media/folder-check-icon.1c21d241.svg";
export { ForwardRef as ReactComponent };